import React, { useMemo, useState,useEffect, useRef } from 'react'
import * as  THREE from 'three'
import { useDispatch } from 'react-redux'

import * as actionCreator from '../../../../action/index';
import { const_var, params } from '../../../../redux/reducers/reducer'

import { CSG } from '../../../../assets/libs/csg-lib'
import { delModel, extrudeSettings, railLoftModel, railModel, roofBaseRailModel } from '../../../../utils/Functions'
import { wallNameArrForValid } from '../../../../utils/Validation'
import { MaterialHighlightTruss, MaterialTruss } from '../../CustomMaterial'

const PillarLegs = ({ leanToKey, angleOffset, setLeanToTrussPosArr,  normalMap, envMap, overlapTrussArr, leftPorchLength, setLeanToLength, dragging }) => {
    const obj_upperTrussNormal = new THREE.Object3D();
    const obj_sideSlopeRail = new THREE.Object3D();
    const obj_loftPieceRail = new THREE.Object3D();
    const obj_outerPillar = new THREE.Object3D();
    const obj_innerPillar = new THREE.Object3D();
    const obj_baseRail = new THREE.Object3D();
    const obj_connectRail = new THREE.Object3D();
    const obj_connectBottomRail = new THREE.Object3D();
    const vector = new THREE.Vector3(1, 0, 0)

    const [upperTrussNormal, setUpperTrussNormal] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]),16 ));
    const [sideSlopeRail, setSideSlopeRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]),16 ));
    const [loftPieceRail, setLoftPieceRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]),16 ))
    const [baseRail, setBaseRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]),16 ));

    const [outerPillar, setOuterPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [innerPillar, setInnerPillar] =  useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    const [connectRail, setConnectRail] =  useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));   
    const [connectBottomRail, setConnectBottomRail] =  useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));

    const [isEqualLeftHeight, setIsEqualLeftHeight] = useState(false);
    const [isEqualRightHeight, setIsEqualRightHeight] = useState(false);
    const [isEqualFrontHeight, setIsEqualFrontHeight] = useState(false);
    const [isEqualBackHeight, setIsEqualBackHeight] = useState(false);
    const [csgLegIdArr, setCsgLegIdArr] = useState([])

    const dispatch = useDispatch();   

    const syncValues = useMemo(() => {
        let height, width, length, pitch, position, pos_z, compRotationY, leanToName, leanToSideName, leanToFrontName, leanToBackName, leanToSideWallName, leanToFrontWallCloseState, leanToBackWallCloseState, legType, isLegTypeChanged, isRightPorch, isLeftPorch, isEqualHeight;
        if (leanToKey === 'front') {
            width = params.leanF_p_w;
            length = params.leanF_p_d;
            height = params.leanF_p_h;
            pitch = parseInt(params.b_l_t_r_pF);
            position = params.leanF_p_pos
            pos_z = params.p_d / 2
            compRotationY = 0
            leanToSideName = 'frontLeanSide'
            leanToFrontName = 'frontLeanFront'
            leanToBackName = 'frontLeanBack'
            leanToName = 'frontlean'
            leanToSideWallName = 'F_L_F_W'
            leanToFrontWallCloseState = params.p_b_c_b_f_f
            leanToBackWallCloseState = params.p_b_c_b_f_b		
            legType = const_var.leanFLegstype
            isLegTypeChanged = params.leanF_p_e_l;
            isLeftPorch = params.add_left_front_lean_porch
            isRightPorch = params.add_right_front_lean_porch
            isEqualHeight = isEqualFrontHeight

        } else if (leanToKey === 'back') {
            width = params.leanB_p_w;
            length = params.leanB_p_d;
            height = params.leanB_p_h;
            pitch = parseInt(params.b_l_t_r_pB);
            position = params.leanB_p_pos
            pos_z = params.p_d / 2
            compRotationY = Math.PI;
            leanToSideName = 'backLeanSide'
            leanToFrontName = 'backLeanFront'
            leanToBackName = 'backLeanBack'
            leanToName = 'backlean'
            leanToSideWallName = 'B_L_S_W'
            leanToFrontWallCloseState = params.p_b_c_b_b_f
            leanToBackWallCloseState = params.p_b_c_b_b_b
            legType = const_var.leanBLegstype
            isLegTypeChanged = params.leanB_p_e_l
            isLeftPorch = params.add_right_back_lean_porch
            isRightPorch = params.add_left_back_lean_porch
            isEqualHeight = isEqualBackHeight
        } else if (leanToKey === 'left') {
            width = params.lean_p_w;
            length = params.lean_p_d;
            height = params.lean_p_h;
            pitch = parseInt(params.b_l_t_r_p);
            position = params.lean_p_pos
            pos_z = params.p_w / 2
            compRotationY = -Math.PI / 2
            leanToSideName = 'leftLeanSide'
            leanToFrontName = 'leftLeanFront'
            leanToBackName = 'leftLeanBack'
            leanToName = 'leftlean'
            leanToSideWallName = 'L_L_L_W'
            leanToFrontWallCloseState = params.p_b_c_b_l_f
            leanToBackWallCloseState = params.p_b_c_b_l_b
            legType = const_var.leanLegstype
            isLegTypeChanged = params.lean_p_e_l;
            isLeftPorch = params.add_left_back_lean_porch
            isRightPorch = params.add_left_front_lean_porch
            isEqualHeight = isEqualLeftHeight
        } else if (leanToKey === 'right'){
            width = params.leanR_p_w;
            length = params.leanR_p_d;
            height = params.leanR_p_h;
            pitch = parseInt(params.b_l_t_r_pR);
            position = params.leanR_p_pos
            pos_z = params.p_w / 2
            compRotationY = Math.PI / 2
            leanToSideName = 'rightLeanSide'
            leanToFrontName = 'rightLeanFront'
            leanToBackName = 'rightLeanBack'
            leanToName = 'rightlean'
            leanToSideWallName = 'R_L_R_W'
            leanToFrontWallCloseState = params.p_b_c_b_r_f
            leanToBackWallCloseState = params.p_b_c_b_r_b
            legType = const_var.leanRLegstype
            isLegTypeChanged = params.leanR_p_e_l
            isLeftPorch = params.add_right_front_lean_porch
            isRightPorch =params.add_right_back_lean_porch
            isEqualHeight = isEqualRightHeight
        } else {
            return null
        }
        
        return {width, length, height, pitch, position, pos_z, compRotationY, leanToSideName, leanToFrontName, leanToBackName, leanToName, leanToSideWallName, leanToFrontWallCloseState, leanToBackWallCloseState, legType, isLegTypeChanged, isLeftPorch, isRightPorch, isEqualHeight}
    },[leanToKey, params.p_d, params.p_w, params.leanF_p_d, params.leanF_p_w, params.leanF_p_h, params.leanF_p_pos, params.b_l_t_r_pF, , params.leanB_p_d, params.leanB_p_w, params.leanB_p_h, params.leanB_p_pos, params.b_l_t_r_pB, params.leanR_p_d, params.leanR_p_w, params.leanR_p_h, params.leanR_p_pos, params.b_l_t_r_pR, params.lean_p_d, params.lean_p_w, params.lean_p_h, params.lean_p_pos, params.b_l_t_r_p, params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.add_right_front_lean_porch, params.add_right_back_lean_porch, params.lean_p_e_l, params.leanR_p_e_l, params.leanF_p_e_l, params.leanB_p_e_l, const_var.leanLegstype, const_var.leanRLegstype, const_var.leanFLegstype, const_var.leanBLegstype, isEqualRightHeight, isEqualLeftHeight, isEqualBackHeight, isEqualFrontHeight, params.p_b_c_b_f_f, params.p_b_c_b_f_b, params.p_b_c_b_b_f, params.p_b_c_b_b_b, params.p_b_c_b_l_f, params.p_b_c_b_l_b, params.p_b_c_b_r_f, params.p_b_c_b_r_b])
    
    const [angle, setAngle] = useState(Math.atan(syncValues.pitch / 12));
    const [isAction, setIsAction] = useState(false);

    const doorDataArr = useMemo(() => {
        let doorArr = []
        if (leanToKey === 'front') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'F_L_F_W' || item.userData.wallName === 'F_L_F_S_W'));
        } else if (leanToKey === 'back') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'B_L_S_W' || item.userData.wallName === 'B_L_F_S_W'))
        } else if (leanToKey === 'left') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'L_L_L_W' || item.userData.wallName === 'L_L_L_S_W'));
        } else if(leanToKey === 'right') {
            doorArr = const_var.newDoorsArray.filter((item) => (item.userData.wallName === 'R_L_R_W' || item.userData.wallName === 'R_L_R_S_W'));
        }

        return doorArr;
    }, [const_var.newDoorsArray, leanToKey]) 

    const trimThickness = 0.2;
    const railWidth = 0.2;
    const railHeight = 0.3;
    const extraLength = 0.2;
    const cbFrontBackWallOffset = 0.16;
    const edgeSlopeRailLength = 2;
    const edgeSlopeRailAlpha = Math.PI / 5.5;

    const leanRoofLeftHeight = useMemo(() => {return ((params.b_l_t_r_p / 12) * params.lean_p_w)}, [params.b_l_t_r_p, params.lean_p_w]) 
    const leanRoofRightHeight = useMemo(() => {return ((params.b_l_t_r_pR / 12) * params.leanR_p_w)}, [params.b_l_t_r_pR, params.leanR_p_w]) 
    const leanRoofFrontHeight = useMemo(() => {return ((params.b_l_t_r_pF / 12) * params.leanF_p_w) }, [params.b_l_t_r_pF, params.leanF_p_w]) 
    const leanRoofBackHeight = useMemo(() => {return ((params.b_l_t_r_pB / 12) * params.leanB_p_w)}, [params.b_l_t_r_pB, params.leanB_p_w])

    const trimOffsetHeight = (params.p_r_p / 12) * trimThickness;
    
    const roofAngle = useMemo(() => {
        return (syncValues.leanToKey === "left") ? Math.atan((leanRoofLeftHeight - (syncValues.isEqualHeight && trimOffsetHeight)) / (syncValues.width - (syncValues.isEqualHeight && trimThickness))) : 
                (syncValues.leanToKey === "right") ? Math.atan((leanRoofRightHeight - (syncValues.isEqualHeight && trimOffsetHeight)) / (syncValues.width - (syncValues.isEqualHeight && trimThickness))) : Math.atan(syncValues.pitch / 12);
    }, [syncValues.leanToKey, leanRoofLeftHeight, leanRoofRightHeight, syncValues.isEqualHeight, syncValues.width, syncValues.pitch]) 

    const outInDistance = useMemo(() => {
        return (syncValues.legType === "double") ? 0.21 : 
       (syncValues.legType === "ladder") ? 0.5 : 
       (syncValues.legType === "zigzag") ? 1 : 0;
    }, [syncValues.legType]) 

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] !== undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])
    
    let count, distance;
        
    const availableSize = syncValues.length;
    const initDistance = legDistance;
    const tempCount = const_var.isUpdate4ftLegLogic && legDistance == 4 ? Math.ceil(availableSize / initDistance) : Math.floor(availableSize / initDistance);
    if (availableSize === tempCount * initDistance) {
        count = tempCount;
        distance = initDistance;
    } else if (availableSize - tempCount * initDistance < initDistance / 2) {
        count = tempCount;
        distance = availableSize / count;
    } else {
        count = tempCount + 1;
        distance = availableSize / count;
    }


    const porchPosInfoArr = useMemo(() => {
        let count, distance;
        
        const initDistance = legDistance;
        const tempAvailableSize = syncValues.width - 0.22;
        const tempCount = Math.floor(tempAvailableSize / initDistance);

        if (tempAvailableSize === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (tempAvailableSize - tempCount * initDistance < initDistance / 2) {
            count = tempCount;
            distance = tempAvailableSize / count;
        } else {
            count = tempCount + 1;
            distance = tempAvailableSize / count;
        }

        return {"leanToKey":leanToKey,"count":tempCount,"distance":distance}
        
    }, [params.add_right_front_lean_porch, params.add_left_front_lean_porch, params.add_right_back_lean_porch, params.add_left_back_lean_porch,])

    const verticalRailLength = useMemo(() =>{
        return Math.sqrt(Math.pow(syncValues.width, 2) + Math.pow(syncValues.width * (syncValues.pitch / 12), 2)) + (params.p_r_s === 1 ? -0.35 : 0.1)
    }, [syncValues.width, syncValues.pitch, params.p_r_s])

    const outerRailLength = useMemo(() =>{
        return syncValues.height - railWidth / 4 + (params.p_r_s === 1 && -cbFrontBackWallOffset * 2 + 0.5) - (((leanToKey === 'left' || leanToKey === 'right') && syncValues.isEqualHeight) ? (0.00005 * params.p_r_p / 12) : 0)
    }, [syncValues.height, params.p_r_s, leanToKey, syncValues.isEqualHeight, params.p_r_p])

    const innerRailLength = useMemo(() =>{
        return syncValues.height + (outInDistance / 2) * syncValues.pitch / 12 + 0.02 - (((leanToKey === 'left' || leanToKey === 'right') && syncValues.isEqualHeight) ? (0.3 * params.p_r_p / 12) : 0) + (params.p_r_s === 1 && (syncValues.legType === "ladder" || syncValues.legType === "zigzag") && (const_var.roofRegularDst * 2 - 0.1));
    }, [syncValues.height, outInDistance, syncValues.pitch, leanToKey, syncValues.isEqualHeight, syncValues.legType, params.p_r_p, params.p_r_s])

    const pillarRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let tempDataInfo;
        
        let innerRailHeight = params.p_h;
        let leanAlignment = 0;

        if (leanToKey === 'front') leanAlignment = params.leantoAlignmentFront;
        else if (leanToKey === 'back') leanAlignment = params.leantoAlignmentBack;
        else if (leanToKey === 'right') leanAlignment = params.leantoAlignmentRight;
        else if (leanToKey === 'left') leanAlignment = params.leantoAlignmentLeft;
        
        for (let i = 0; i <= count; i++) {
            let pos_x;
            if(leanToKey === 'front' || leanToKey === 'back'){
                if(i === 0 ) pos_x = distance * i - availableSize / 2 + railWidth;
                else if(i === count) pos_x = distance * i - availableSize / 2 - railWidth;
                else pos_x = distance * i - availableSize / 2;
            } else {
                if (i === 0) pos_x = distance * i - availableSize / 2 + 0.05;
                else if (i === count) pos_x = distance * i - availableSize / 2 - 0.05;
                else pos_x = distance * i - availableSize / 2;            
            }
            
            if (dragging) {
                innerRailHeight = params.p_h
            } else {
                if (syncValues.length === params.p_w && (i === 0 || i === count)) innerRailHeight = 0;
                else if (Number(leanAlignment) === 2 && i === 0) innerRailHeight = 0;
                else if (Number(leanAlignment) === 3 && i === count) innerRailHeight = 0;
                else innerRailHeight = params.p_h + (params.p_w / 2 - Math.abs(pos_x + (leanToKey === 'front' ? syncValues.position : (-syncValues.position)))) * (params.p_r_p / 12) - railWidth / 2 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0)
            }
            
            tempDataInfo = {
                pos_x: pos_x,
                inner_rail: {
                    // length: dragging ? params.p_h : params.p_h + (params.p_w / 2 - Math.abs(pos_x + (leanToKey === 'front' ? syncValues.position : (-syncValues.position)))) * (params.p_r_p / 12) - railWidth / 2 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0),
                    length: innerRailHeight,
                    pos_z: syncValues.pos_z,
                },
                outer_rail: {
                    length: outerRailLength,
                    pos_z: syncValues.pos_z + syncValues.width - ((leanToKey === 'front' || leanToKey === 'back') ? (railHeight / 2 - cbFrontBackWallOffset) : (railWidth - 0.05)),
                },
                outer_in_rail: {
                    length: innerRailLength,
                    pos_z: syncValues.pos_z + syncValues.width - ((leanToKey === 'front' || leanToKey === 'back') ? (railHeight / 2 - cbFrontBackWallOffset) : (railWidth - 0.05)) - outInDistance,
                },
                roof_rail: {
                    length: verticalRailLength,
                    pos_y: (leanToKey === 'front' || leanToKey === 'back') ? 
                           (syncValues.height + syncValues.width * (syncValues.pitch / 12) - railWidth / 2 - (isEqualFrontHeight ? 0.121 : 0.085)) + (params.p_r_s === 1 ? (const_var.roofRegularDst * 2 + 0.06 ) : 0) : 
                           (syncValues.height + syncValues.width * (syncValues.pitch / 12) - railWidth / 2 + (params.p_r_s === 1 ? (const_var.roofRegularDst * 2 + 0.06 ) : params.p_r_s === 2 ? -0.025 : 0) - (isEqualRightHeight ? 0.14: 0.07)),
                    pos_z: syncValues.pos_z + ((leanToKey === 'front' || leanToKey === 'back') ? extraLength : 0.02),
                    alpha: -(Math.PI / 2 + Math.atan(syncValues.pitch / 12)),
                },
                loft_rail: {
                    length: railHeight,
                    pos_x: pos_x - railHeight / 2,
                    pos_y: syncValues.height - railWidth / 4 - cbFrontBackWallOffset * 2 + 0.38,
                    pos_z: syncValues.pos_z - 0.05 + syncValues.width + ((leanToKey === 'front' || leanToKey === 'back') ? cbFrontBackWallOffset : 0) ,
                },
                slope_rail: {
                    length: edgeSlopeRailLength,
                    alpha: edgeSlopeRailAlpha,
                    pos_y: syncValues.height + (params.p_r_s === 1 ? (const_var.roofRegularDst * 2) : 0) - (edgeSlopeRailLength * Math.cos(edgeSlopeRailAlpha) - (edgeSlopeRailLength * Math.sin(edgeSlopeRailAlpha)) * Math.tan(syncValues.pitch / 12)) - syncValues.pitch / 100 + (params.add_left_front_lean_porch || params.add_right_front_lean_porch ? -0.02 : 0.025) - (((leanToKey === 'left' || leanToKey === 'right') && syncValues.isEqualHeight) ? (0.3 * params.p_r_p / 12) : 0),
                    pos_z: syncValues.pos_z + syncValues.width + ((leanToKey === 'front' || leanToKey === 'back') ? (railWidth - cbFrontBackWallOffset - 0.05) : (-0.15)),
                }
            }

            dataInfoArray.push(tempDataInfo);
        }
        let posArr = []
        dataInfoArray.map((item) => {
            posArr.push(item.pos_x - ((leanToKey === 'front' || leanToKey === 'left') ? (-syncValues.position) : (syncValues.position)))
        });
        setLeanToTrussPosArr(posArr)

        // push the valuse of porches leg position to highlight 
        let NewPosArr = JSON.parse(JSON.stringify(posArr))
        let lastIndexValue = NewPosArr[NewPosArr.length-1]
        let firstIndexValue = NewPosArr[0]
        let j = lastIndexValue
        let h = firstIndexValue
        for (let i = 1; i <=  porchPosInfoArr.count; i++) {  
            j = j + porchPosInfoArr.distance
            h = h - porchPosInfoArr.distance
            NewPosArr.push(j)
            NewPosArr.push(h)
        }
        NewPosArr.sort(function(a, b){return a - b});
        dispatch(actionCreator.setLeanToLegPosObj(NewPosArr,leanToKey));
        
        return dataInfoArray;
    }, [leanToKey, syncValues.length, params.p_h, params.p_w, params.p_r_p, syncValues.pos_z, syncValues.height, params.p_r_s, syncValues.width, syncValues.pitch, legDistance, isEqualFrontHeight, syncValues.position, outInDistance, syncValues.legType, syncValues.isLeftPorch, syncValues.isRightPorch, syncValues.position, dragging, params.add_right_front_lean_porch, params.add_left_front_lean_porch, edgeSlopeRailAlpha, distance, availableSize, count, syncValues.isEqualHeight, params.p_r_p])
    
    const baseBottomRailDataArr = useMemo(() => {
        let dataInfoArray = [];

        const availableSize = syncValues.length - 0.2;

        const backRailData = {
            pos_x: -syncValues.length / 2,
            pos_y: railWidth / 2,
            pos_z: syncValues.pos_z,
            length: syncValues.length,
        }
        const outerRailData = {
            pos_x: -availableSize / 2,
            pos_y: railWidth / 2,
            pos_z: syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - ((leanToKey === 'front' || leanToKey === 'back') ? (railHeight / 2) : (railHeight + 0.01)),
            length: availableSize,
        }
        
        const innerRailData = {
            pos_x: -availableSize / 2,
            pos_y: railWidth / 2,
            pos_z: syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - outInDistance - ((leanToKey === 'front' || leanToKey === 'back') ?  (railHeight / 2) : (railHeight + 0.01)),
            length: availableSize,
        }

        dataInfoArray.push({
            back : backRailData,
            outer : outerRailData,
            inner : innerRailData
        });

        return {dataInfoArray};
    }, [syncValues.pos_z, params.p_d, syncValues.width, syncValues.length, outInDistance, syncValues.legType])

    const connectRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance;

        let initDistance = (syncValues.legType === 'zigzag') ? 1 : 2;
        const tempCount = Math.floor(syncValues.height / initDistance);
        if (syncValues.height === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (syncValues.height - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = syncValues.height / count;
        } else {
            count = tempCount + 1;
            distance = syncValues.height / count;
        }
        const isEven = (i) => {
            return i % 2 === 0;
        }

        for (let i = 0; i < count; i++) {            
            const length = ((i === 0) ? outInDistance : (outInDistance / Math.cos(Math.PI / 4)))
            const pos_z = syncValues.pos_z + syncValues.width - ((leanToKey === 'front' || leanToKey === 'back') ? (0) : (railHeight / 2)) - (syncValues.legType === 'zigzag' ? (!isEven(i) ? outInDistance : 0) : outInDistance);
            const pos_y = distance * i + railWidth / 2;
            const rotationX = Math.atan((distance) / outInDistance)

            const tempInfoObj = {
                pos_z: pos_z,
                distance,
                pos_y: pos_y,
                length: syncValues.legType === 'zigzag' ? length : outInDistance,
                rotationX: syncValues.legType === 'zigzag' ? isEven(i) ? (i === 0 ? Math.PI : (Math.PI / 2 + rotationX)) : rotationX : 0
            }

            dataInfoArray.push(tempInfoObj);
        }
        const lengthZigzag = outInDistance / Math.cos(Math.PI / 4);
        const lengthLadder = outInDistance;

        return {lengthZigzag, lengthLadder, dataInfoArray}
    }, [syncValues.height, params.p_d, syncValues.width, syncValues.pos_z, syncValues.legType, outInDistance, leanToKey])

    const roofPatternRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance, tempDataInfo;
        
        const initDistance = 3;
        const tempCount = Math.floor(syncValues.width / initDistance);
        if (syncValues.width === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (syncValues.width - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = syncValues.width / count;
        } else {
            count = tempCount + 1;
            distance = syncValues.width / count;
        }

        const initPosZ = 0.5
        const thickness = (leanToKey === 'front' || leanToKey === 'back') ?  (syncValues.isEqualHeight ? (2.5 - syncValues.pitch) * 0.045 / 4 + 0.2 : (2.5 - syncValues.pitch) * 0.045 / 4) : (syncValues.isEqualHeight ? 0.19 * params.p_r_p / 12 : 0.035)
        for (let i = 0; i < count; i++) {
            tempDataInfo = {
                pos_x: -syncValues.length / 2,
                pos_y: syncValues.height + (syncValues.width - distance * i - initPosZ) * (syncValues.pitch / 12) - thickness,
                pos_z: syncValues.pos_z + distance * i + initPosZ,
                length: syncValues.length,
                
                alpha: roofAngle,
            }
            
            dataInfoArray.push(tempDataInfo);
        }
        
        return dataInfoArray;
    }, [syncValues.pos_z, params.p_d, syncValues.height, syncValues.length, syncValues.pitch, syncValues.width, syncValues.isEqualHeight, params.p_r_p])

    const frontBackPillarRailDataArr = useMemo(() => {
        let dataInfoArray = []
        let count, distance = 0;

        const initDistance = legDistance;
        
        const tempCount = Math.floor(syncValues.width / initDistance);
        if (syncValues.width === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (syncValues.width - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = syncValues.width / count;
        } else {
            count = tempCount + 1;
            distance = syncValues.width / count;
        }
        
        for (let i = 1; i < count; i++) {
            const pos_z = distance * i - syncValues.pos_z - syncValues.width;
            const length = syncValues.height + (syncValues.width + syncValues.pos_z - Math.abs(pos_z)) * (syncValues.pitch / 12) - railWidth / 2 + (params.p_r_s === 1 && const_var.roofRegularDst * 2);
            
            const tempInfoObj ={
                pos_z: pos_z,
                length: length
            }
            
            dataInfoArray.push(tempInfoObj);
        }
        
        return dataInfoArray;
    }, [syncValues.width, syncValues.pos_z, legDistance, syncValues.height, syncValues.pitch, params.p_r_s])

    /************** cutting hole using CSG ***************/
    
    const innerDoorModel = new THREE.Mesh(
        new THREE.ExtrudeGeometry(delModel(leanToKey, 'leg'), extrudeSettings(2)),
        new THREE.MeshStandardMaterial({ color: 'brown' })
    )
    const innerDoorModel_Temp = innerDoorModel.clone();
    // innerDoorModel_Temp.position.set(alignPosOffset, 0, params.p_d / 2 + cbFrontBackWallOffset - 0.5);
    innerDoorModel_Temp.rotateY(((leanToKey === 'front' || leanToKey === 'right') ? (0) : (Math.PI)))
    innerDoorModel_Temp.position.set(((leanToKey === 'front' || leanToKey === 'left') ? (-syncValues.position) : (syncValues.position)), 0, syncValues.pos_z + cbFrontBackWallOffset - ((leanToKey === 'front' || leanToKey === 'right') ? (1.5) : (-0.5)));
    innerDoorModel_Temp.updateMatrixWorld();
    
    const outerDoorModel = new THREE.Mesh(
        new THREE.ExtrudeGeometry(delModel(syncValues.leanToSideName, 'leg'), extrudeSettings(2)),
        new THREE.MeshStandardMaterial({ color: 'brown' })
    )
    const outerDoorModel_Temp = outerDoorModel.clone();
    // outerDoorModel_Temp.position.set(alignPosOffset, 0, params.p_d / 2 + syncValues.width + cbFrontBackWallOffset - 0.5);
    outerDoorModel_Temp.rotateY(((leanToKey === 'front' || leanToKey === 'right') ? (0) : (Math.PI)))
    outerDoorModel_Temp.position.set(((leanToKey === 'front' || leanToKey === 'left') ? (-syncValues.position) : (syncValues.position)), 0, syncValues.pos_z + syncValues.width + cbFrontBackWallOffset - ((leanToKey === 'front' || leanToKey === 'right') ? (1.5) : (-0.5)));
    outerDoorModel_Temp.updateMatrixWorld();

    const CSGFrontBackPillarRailModelArr = useMemo(() => {
        let frontModelArr = [];
        let backModelArr = [];

        const modelShape = railModel(railWidth, railHeight);
        
        frontBackPillarRailDataArr.map((item) => {    
            const meshFrontPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshBackPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            let meshFrontPillarRailModel_Temp = meshFrontPillarRailModel.clone(); 
            meshFrontPillarRailModel_Temp.position.set(0, 0, -item.pos_z);
            meshFrontPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshFrontPillarRailModel_Temp.rotateZ(Math.PI / 2);
            meshFrontPillarRailModel_Temp.updateMatrix();
            meshFrontPillarRailModel_Temp.updateMatrixWorld();

            let meshBackPillarRailModel_Temp = meshBackPillarRailModel.clone(); 
            meshBackPillarRailModel_Temp.position.set(0, 0, -item.pos_z);
            meshBackPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshBackPillarRailModel_Temp.rotateZ(Math.PI / 2);
            meshBackPillarRailModel_Temp.updateMatrix();
            meshBackPillarRailModel_Temp.updateMatrixWorld();

            const outerFrontDoorModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(delModel(syncValues.leanToFrontName, 'leg'), extrudeSettings(2)),
                new THREE.MeshStandardMaterial({ color: 'brown' })
            )

            const outerbackDoorModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(delModel(syncValues.leanToBackName, 'leg'), extrudeSettings(2)),
                new THREE.MeshStandardMaterial({ color: 'brown' })
            )

            const outerFrontDoorModel_Temp = outerFrontDoorModel.clone();
            outerFrontDoorModel_Temp.rotateY((leanToKey === 'front'|| leanToKey === 'left') ? Math.PI / 2 : -Math.PI / 2)
            outerFrontDoorModel_Temp.position.set((leanToKey === 'front'|| leanToKey === 'left') ? -1 : 1, 0, 0);
            outerFrontDoorModel_Temp.updateMatrixWorld();
        
            const outerBackDoorModel_Temp = outerbackDoorModel.clone();
            outerBackDoorModel_Temp.rotateY((leanToKey === 'front'|| leanToKey === 'left') ? Math.PI / 2 : -Math.PI / 2)
            outerBackDoorModel_Temp.position.set((leanToKey === 'front'|| leanToKey === 'left') ? -1 : 1, 0, 0);
            outerBackDoorModel_Temp.updateMatrixWorld();
            
            const meshFrontPillarRailModel_CSG = CSG.fromMesh(meshFrontPillarRailModel_Temp);
            const meshBackPillarRailModel_CSG = CSG.fromMesh(meshBackPillarRailModel_Temp);
            const outerFrontDoorModel_CSG = CSG.fromMesh(outerFrontDoorModel_Temp);
            const outerBackDoorModel_CSG = CSG.fromMesh(outerBackDoorModel_Temp);

            const meshFrontPillarDelModel_CSG = meshFrontPillarRailModel_CSG.subtract(outerFrontDoorModel_CSG);
            const meshBackPillarDelModel_CSG = meshBackPillarRailModel_CSG.subtract(outerBackDoorModel_CSG);

            const CSGFrontPillarRailModel = CSG.toMesh(
                meshFrontPillarDelModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            const CSGBackPillarRailModel = CSG.toMesh(
                meshBackPillarDelModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            frontModelArr.push(CSGFrontPillarRailModel);
            backModelArr.push(CSGBackPillarRailModel);
            
            return null;   
            
        })
        return {frontModelArr, backModelArr}
    }, [params.backLeanStoragePosition, params.frontLeanStoragePosition, params.rightLeanStoragePosition, params.leftLeanStoragePosition, frontBackPillarRailDataArr, syncValues.leanToFrontName, syncValues.leanToBackName, const_var.newDoorsArray, leanToKey])

    const CSGFrontBackBottomRailData = useMemo(() => {

        const modelShape = railModel(railHeight, railWidth);

        const meshBottomRailModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(modelShape, extrudeSettings(syncValues.width)),
            new THREE.MeshStandardMaterial({ color: 'pink' })
        )

        let meshFrontBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshFrontBottomRailModel_Temp.position.set((leanToKey === 'left' ? -0.05 : (leanToKey === 'right' ? 0.05 : 0)), railWidth / 2, syncValues.pos_z - railWidth / 2);
        meshFrontBottomRailModel_Temp.updateMatrix();
        meshFrontBottomRailModel_Temp.updateMatrixWorld();

        let meshBackBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshBackBottomRailModel_Temp.position.set((leanToKey === 'left' ? 0.05 : (leanToKey === 'right' ? -0.05 : 0)), railWidth / 2, syncValues.pos_z - railWidth / 2);
        meshBackBottomRailModel_Temp.updateMatrix();
        meshBackBottomRailModel_Temp.updateMatrixWorld();

        const outerFrontDoorModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(delModel(syncValues.leanToFrontName, 'leg'), extrudeSettings(2)),
            new THREE.MeshStandardMaterial({ color: 'brown' })
        )

        const outerbackDoorModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(delModel(syncValues.leanToBackName, 'leg'), extrudeSettings(2)),
            new THREE.MeshStandardMaterial({ color: 'brown' })
        )

        const outerFrontDoorModel_Temp = outerFrontDoorModel.clone();
        const outerBackDoorModel_Temp = outerbackDoorModel.clone();
        if (leanToKey === 'front' || leanToKey === 'left') {
            outerFrontDoorModel_Temp.rotateY(Math.PI / 2);
            outerBackDoorModel_Temp.rotateY(Math.PI / 2);
        } else {
            outerFrontDoorModel_Temp.rotateY(-Math.PI / 2);
            outerBackDoorModel_Temp.rotateY(-Math.PI / 2);
        }
        if (leanToKey === 'front' || leanToKey === 'left') {
            outerFrontDoorModel_Temp.position.set(-1, 0, 0);
            outerBackDoorModel_Temp.position.set(-1, 0, 0);
        } else {
            outerFrontDoorModel_Temp.position.set(1, 0, 0);
            outerBackDoorModel_Temp.position.set(1, 0, 0);
        }
        outerFrontDoorModel_Temp.updateMatrixWorld();
        outerBackDoorModel_Temp.updateMatrixWorld();
  
        const meshFrontBottomRailModel_CSG = CSG.fromMesh(meshFrontBottomRailModel_Temp);
        const meshBackBottomRailModel_CSG = CSG.fromMesh(meshBackBottomRailModel_Temp);
        const outerFrontDoorModel_CSG = CSG.fromMesh(outerFrontDoorModel_Temp);
        const outerBackDoorModel_CSG = CSG.fromMesh(outerBackDoorModel_Temp);

        const meshFrontBottomRailDelModel_CSG = meshFrontBottomRailModel_CSG.subtract(outerFrontDoorModel_CSG)
        const meshbackBottomRailDelModel_CSG = meshBackBottomRailModel_CSG.subtract(outerBackDoorModel_CSG)

        const CSGFrontBottomRailModel = CSG.toMesh(
            meshFrontBottomRailDelModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        const CSGBackBottomRailModel = CSG.toMesh(
            meshbackBottomRailDelModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        return {CSGFrontBottomRailModel, CSGBackBottomRailModel}

    }, [syncValues.width, syncValues.pos_z, syncValues.leanToFrontName, syncValues.leanToBackName, const_var.newDoorsArray])
    
    const CSGPillarRailModelArr = useMemo(() => {
        let innerModelArr = [];
        let outerModelArr = [];
        let outerInModelArr = [];
        // let connectModelArr = []
        
        pillarRailDataArr.map((item) => {
            const innerModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railHeight, railWidth), extrudeSettings(item.inner_rail.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let innerModel_Temp = innerModel.clone();
            innerModel_Temp.rotateX(-Math.PI / 2);
            innerModel_Temp.position.set(item.pos_x, 0, item.inner_rail.pos_z);
            innerModel_Temp.updateMatrixWorld();
            //
            const outerModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railHeight, railWidth), extrudeSettings(item.outer_rail.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let outerModel_Temp = outerModel.clone();
            outerModel_Temp.rotateX(-Math.PI / 2);
            outerModel_Temp.position.set(item.pos_x, 0, item.outer_rail.pos_z);
            outerModel_Temp.updateMatrixWorld();
            //
            const outerInModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railHeight, railWidth), extrudeSettings(item.outer_in_rail.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let outerInModel_Temp = outerInModel.clone();
            outerInModel_Temp.rotateX(-Math.PI / 2);
            outerInModel_Temp.position.set(item.pos_x, 0, item.outer_in_rail.pos_z);
            outerInModel_Temp.updateMatrixWorld();

            const innerModel_Mesh_Temp = CSG.fromMesh(innerModel_Temp);
            const innerDoorModel_Mesh_Temp = CSG.fromMesh(innerDoorModel_Temp);
            const outerModel_Mesh_Temp = CSG.fromMesh(outerModel_Temp);
            const outerDoorModel_Mesh_Temp = CSG.fromMesh(outerDoorModel_Temp);
            const outerInModel_Mesh_Temp = CSG.fromMesh(outerInModel_Temp);

            const CSG_InnerModel_Temp = innerModel_Mesh_Temp.subtract(innerDoorModel_Mesh_Temp);
            const CSG_OuterModel_Temp = outerModel_Mesh_Temp.subtract(outerDoorModel_Mesh_Temp);
            const CSG_OuterInModel_Temp = outerInModel_Mesh_Temp.subtract(outerDoorModel_Mesh_Temp);

            const CSG_InnerModel = CSG.toMesh(
                CSG_InnerModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
            const CSG_OuterModel = CSG.toMesh(
                CSG_OuterModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
            const CSG_OuterInModel = CSG.toMesh(
                CSG_OuterInModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )

            // connectRailDataArr.map((item_connect) => {
            //     const meshLeftConnectRailModel = new THREE.Mesh(
            //         new THREE.ExtrudeGeometry(railModel(railHeight, railWidth), extrudeSettings(item_connect.length)),
            //         new THREE.MeshStandardMaterial({ color: 'pink' })
            //     )
            //     let meshLeftConnectRailModel_Temp = meshLeftConnectRailModel.clone();    
            //     meshLeftConnectRailModel_Temp.position.set(item.pos_x, item_connect.pos_y, item_connect.pos_z);
            //     meshLeftConnectRailModel_Temp.rotateX(item_connect.rotationX);
            //     meshLeftConnectRailModel_Temp.updateMatrix();
            //     meshLeftConnectRailModel_Temp.updateMatrixWorld();
            //     const meshLeftConnectRailModel_CSG = CSG.fromMesh(meshLeftConnectRailModel_Temp);
    
            //     const leftConnectRailModel_CSG = meshLeftConnectRailModel_CSG.subtract(outerDoorModel_Mesh_Temp);
            //     const CSGLeftConnectRailModel = CSG.toMesh(
            //         leftConnectRailModel_CSG,
            //         new THREE.Matrix4(),
            //         new THREE.MeshStandardMaterial({ color: 'blue' })
            //     )
                
            //     connectModelArr.push(CSGLeftConnectRailModel);
                
            //     return null;
            // })

            innerModelArr.push(CSG_InnerModel);
            outerModelArr.push(CSG_OuterModel);
            outerInModelArr.push(CSG_OuterInModel);

            return null;
        })
        const outerDoorModel_Mesh_Temp = CSG.fromMesh(outerDoorModel_Temp);
        const delModelShow = CSG.toMesh(
            outerDoorModel_Mesh_Temp,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'red' })
        )
        return { 
            innerModelArr, 
            outerModelArr, 
            outerInModelArr, 
            // connectModelArr, 
            delModelShow 
        }
    }, [pillarRailDataArr, connectRailDataArr, const_var.newDoorsArray])

    const CSGBottomRailModelArr = useMemo(() => {
        let modelArr = [];
        baseBottomRailDataArr.dataInfoArray.map((item) => {
            const backModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railWidth, railWidth), extrudeSettings(item.back.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let backModel_Temp = backModel.clone();
            backModel_Temp.rotateY(Math.PI / 2);
            backModel_Temp.position.set(item.back.pos_x, item.back.pos_y, item.back.pos_z);
            backModel_Temp.updateMatrixWorld();
            
            const outerModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(railModel(railWidth, railWidth), extrudeSettings(item.outer.length)),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            let outerModel_Temp = outerModel.clone();
            outerModel_Temp.rotateY(Math.PI / 2);
            outerModel_Temp.position.set(item.outer.pos_x, item.outer.pos_y, item.outer.pos_z);
            outerModel_Temp.updateMatrixWorld();
            
            let innerModel_Temp = outerModel.clone();
            innerModel_Temp.rotateY(Math.PI / 2);
            innerModel_Temp.position.set(item.inner.pos_x, item.inner.pos_y, item.inner.pos_z);
            innerModel_Temp.updateMatrixWorld();

            const backModel_Mesh_Temp = CSG.fromMesh(backModel_Temp);
            const innerDoorModel_Mesh_Temp = CSG.fromMesh(innerDoorModel_Temp);
            const outerModel_Mesh_Temp = CSG.fromMesh(outerModel_Temp);
            const innerModel_Mesh_Temp = CSG.fromMesh(innerModel_Temp);
            const delDoorModel_Mesh_Temp = CSG.fromMesh(outerDoorModel_Temp);
    
            const CSG_BackModel_Temp = backModel_Mesh_Temp.subtract(innerDoorModel_Mesh_Temp);
            const CSG_OuterModel_Temp = outerModel_Mesh_Temp.subtract(delDoorModel_Mesh_Temp);
            const CSG_InnerModel_Temp = innerModel_Mesh_Temp.subtract(delDoorModel_Mesh_Temp);
    
            const CSG_BackModel = CSG.toMesh(
                CSG_BackModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
            const CSG_OuterModel = CSG.toMesh(
                CSG_OuterModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
            const CSG_InnerModel = CSG.toMesh(
                CSG_InnerModel_Temp,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
    
            modelArr.push({
                back : CSG_BackModel,
                outer : CSG_OuterModel,
                inner : CSG_InnerModel
            });

            return null;
        })

        return {modelArr};
        
    }, [baseBottomRailDataArr, innerDoorModel_Temp, outerDoorModel_Temp])
    
    useMemo(() => {
        if(params.p_h === leanRoofLeftHeight + params.lean_p_h) setIsEqualLeftHeight(true)
        else setIsEqualLeftHeight(false)
        if(params.p_h === leanRoofRightHeight + params.leanR_p_h) setIsEqualRightHeight(true)
        else setIsEqualRightHeight(false)
        if(params.p_h === leanRoofFrontHeight + params.leanF_p_h) setIsEqualFrontHeight(true)
        else setIsEqualFrontHeight(false)
        if(params.p_h === leanRoofBackHeight + params.leanB_p_h) setIsEqualBackHeight(true)
            else setIsEqualBackHeight(false)
    
    }, [leanRoofFrontHeight, leanRoofLeftHeight, leanRoofBackHeight, leanRoofRightHeight, params.p_h, params.lean_p_h, params.leanR_p_h, params.leanF_p_h, params.leanB_p_h])
    

    useMemo(() => {
        if (pillarRailDataArr.length > 0) {
            setLeanToLength(pillarRailDataArr.length);
        }
    }, [pillarRailDataArr, syncValues.isAddLeanTo, syncValues.isLeftPorch, syncValues.isRightPorch, syncValues.position])

    useMemo(() => {        
            let index_all = 0;
            const instancedMatUpperTrussNormal = [];
            const instancedMatSideSlopeRail = [];
            const instancedMatLoftPieceRail = [];
            const instancedMatBaseRail = [];
            pillarRailDataArr.map((item, index_truss) => {
                //----- upper truss -----
                obj_upperTrussNormal.position.set(item.pos_x, item.roof_rail.pos_y - (syncValues.isEqualHeight && (0.19 * params.p_r_p / 12)), item.roof_rail.pos_z);
                obj_upperTrussNormal.rotation.x = -Math.PI / 2;
                obj_upperTrussNormal.rotateOnAxis(vector, (isAction ? (angle + Math.PI / 2) : -item.roof_rail.alpha));
                
                if (!!overlapTrussArr && overlapTrussArr.buildingType === syncValues.leanToName && overlapTrussArr.idArr.includes(index_truss + (syncValues.isLeftPorch ? leftPorchLength : 0))) {
                    obj_upperTrussNormal.scale.setScalar(0);
                } else {
                    obj_upperTrussNormal.scale.setScalar(1);
                }

                obj_upperTrussNormal.updateMatrix();
                instancedMatUpperTrussNormal.push(...obj_upperTrussNormal.matrix.elements);
                //---------------------

                //----- slope rail-----
                obj_sideSlopeRail.position.set(item.pos_x, item.slope_rail.pos_y, item.slope_rail.pos_z);
                
                obj_sideSlopeRail.rotation.x = -Math.PI / 2;
                obj_sideSlopeRail.rotateOnAxis(vector, -item.slope_rail.alpha);

                let slope_rail_overlap = false;

                doorDataArr.map((item_door) => {                            
                    if (item_door.positionX - item_door.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position)  < item.pos_x + railHeight / 2 &&
                        item_door.positionX + item_door.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position)  >= item.pos_x - railWidth / 2 &&
                        item_door.positionY + item_door.height / 2 >= item.slope_rail.pos_y
                    ) {
                        slope_rail_overlap = true;
                    }
                    return null;
                })

                if (slope_rail_overlap === true) obj_sideSlopeRail.scale.setScalar(0);
                else  obj_sideSlopeRail.scale.setScalar(1);
                
                obj_sideSlopeRail.updateMatrix();
                instancedMatSideSlopeRail.push(...obj_sideSlopeRail.matrix.elements);
                //---------------------
                
                //----- loft piece rail-----
                obj_loftPieceRail.position.set(item.loft_rail.pos_x, item.loft_rail.pos_y, item.loft_rail.pos_z);
                obj_loftPieceRail.rotation.y = Math.PI / 2;

                if (params.p_r_s !== 1) obj_loftPieceRail.scale.setScalar(0);
                else obj_loftPieceRail.scale.setScalar(1);
                
                obj_loftPieceRail.updateMatrix();
                instancedMatLoftPieceRail.push(...obj_loftPieceRail.matrix.elements);
                //---------------------

                index_all ++;
            })  

            //----- base rail-----
            let index_all1 = 0;
            roofPatternRailDataArr.forEach((item, index_truss) => {
                obj_baseRail.position.set(item.pos_x, item.pos_y - (isAction && (trimOffsetHeight - Math.tan(angle) * 0.2)), item.pos_z);
                obj_baseRail.rotation.y = Math.PI / 2;
                obj_baseRail.rotation.x = item.alpha
                
                if(params.p_r_s === 3) obj_baseRail.scale.setScalar(1);
                else obj_baseRail.scale.setScalar(0);

                // obj_baseRail.rotateOnAxis(vector, item.alpha)
                
                obj_baseRail.updateWorldMatrix();
                instancedMatBaseRail.push(...obj_baseRail.matrix.elements);
                
                //---------------------
                index_all1 ++
            })
            
            setUpperTrussNormal(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatUpperTrussNormal), 16));
            setSideSlopeRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatSideSlopeRail), 16));
            setLoftPieceRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLoftPieceRail), 16));
            setBaseRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatBaseRail), 16));
        
    }, [pillarRailDataArr, overlapTrussArr, doorDataArr, isAction, params.p_r_s, angle, trimOffsetHeight, leanToKey, syncValues.leanToName, syncValues.isLeftPorch, leftPorchLength, syncValues.position, roofPatternRailDataArr, syncValues.isEqualHeight, params.p_r_p])

    useMemo(() => {
        let tempCSGLegIdArr = [];
        let isShowLeg = true;
        
        const sideCmpArry = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes(syncValues.leanToSideWallName)).includes(item.userData.wallName))];
        
        const instanceMatInnerPillar = [];
        const instanceMatOuterPillar = [];
        const instanceMatConnectRail = [];
        const instanceMatConnectBottomRail = [];

        pillarRailDataArr.forEach((item, index_truss) => {

            obj_outerPillar.position.set(item.pos_x, 0, item.outer_rail.pos_z);
            obj_outerPillar.rotation.x = -Math.PI / 2;
            obj_innerPillar.position.set(item.pos_x, 0, item.outer_in_rail.pos_z);
            obj_innerPillar.rotation.x = -Math.PI / 2;

            isShowLeg = true
            sideCmpArry.every(element => {
                if (item.pos_x + railHeight >= (element.positionX - element.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position)) && item.pos_x - railHeight <= element.positionX + element.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position)) {
                    isShowLeg = false;
                    tempCSGLegIdArr.push(index_truss);
                    return false;
                }
                else return true;
            })
            if (!isShowLeg || (!!overlapTrussArr && overlapTrussArr.buildingType === syncValues.leanToName && overlapTrussArr.idArr.includes(index_truss + (syncValues.isLeftPorch ? leftPorchLength : 0)))) {
                obj_outerPillar.scale.setScalar(0);
            } else {
                obj_outerPillar.scale.setScalar(1);
            }

            if (!isShowLeg) {
                obj_innerPillar.scale.setScalar(0);
            } else {
                obj_innerPillar.scale.setScalar(1);
            }

            //--- connect leg
            obj_connectBottomRail.position.set(item.pos_x, railWidth / 2, item.outer_in_rail.pos_z)
            if((syncValues.isLegTypeChanged == true && (syncValues.legType == "ladder" || syncValues.legType == "zigzag"))) obj_connectBottomRail.scale.setScalar(1);
            else obj_connectBottomRail.scale.setScalar(0)

            sideCmpArry.filter(filterElement => filterElement.userData.compType === "garage_door" || filterElement.userData.compType === "garage_door_frameout" || filterElement.userData.compType === "walkin" || filterElement.userData.compType === "walkin_frameout").forEach(element => {
                if (item.pos_x + railHeight >= (element.positionX) - element.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position) && item.pos_x - railHeight <= (element.positionX) + element.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position)) {
                    obj_connectBottomRail.scale.setScalar(0);
                }
            })

            connectRailDataArr.dataInfoArray.forEach((item_cnt, index_cnt) => {
                if (index_cnt === 0)  return;

                obj_connectRail.position.set(item.pos_x, item_cnt.pos_y, item_cnt.pos_z);
                obj_connectRail.rotation.x = item_cnt.rotationX;
                if((syncValues.isLegTypeChanged == true && (syncValues.legType == "ladder" || syncValues.legType == "zigzag"))) obj_connectRail.scale.setScalar(1);
                else obj_connectRail.scale.setScalar(0)

                sideCmpArry.forEach((element) => {
                    if (item.pos_x + railHeight >= (element.positionX) - element.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position) && item.pos_x - railHeight <= (element.positionX) + element.width / 2 + ((leanToKey === 'front' || leanToKey === 'left') ? -syncValues.position : syncValues.position)) {
                        const itemPosY = syncValues.legType === 'ladder' ? item_cnt.pos_y : item_cnt.pos_y - item_cnt.distance
                        
                        if (element.userData.compType === "garage_door" || element.userData.compType === "garage_door_frameout" || element.userData.compType === "walkin" || element.userData.compType === "walkin_frameout") {
                            if (itemPosY - railWidth / 2 <= element.height) {
                                obj_connectRail.scale.setScalar(0);
                            }
                        } else {
                            if (itemPosY - railWidth / 2 <= element.positionY + element.height / 2 && item_cnt.pos_y + railWidth / 2 >= element.positionY - element.height / 2) {
                                obj_connectRail.scale.setScalar(0);
                            }
                        }
                    }
                })       
                
                obj_connectRail.updateMatrix();
                instanceMatConnectRail.push(...obj_connectRail.matrix.elements);
            })

            obj_connectBottomRail.updateMatrix();
            instanceMatConnectBottomRail.push(...obj_connectBottomRail.matrix.elements);

            //----------

            obj_outerPillar.updateMatrix();
            instanceMatOuterPillar.push(...obj_outerPillar.matrix.elements);
            obj_innerPillar.updateMatrix();
            instanceMatInnerPillar.push(...obj_innerPillar.matrix.elements);
        })

        setCsgLegIdArr(tempCSGLegIdArr)
        setOuterPillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatOuterPillar), 16));

        setInnerPillar(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatInnerPillar), 16));

        setConnectRail(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatConnectRail), 16));
        setConnectBottomRail(new THREE.InstancedBufferAttribute(new Float32Array(instanceMatConnectBottomRail), 16));
    
    }, [params.p_w, const_var.newDoorsArray, pillarRailDataArr, overlapTrussArr, syncValues.leanToSideWallName, syncValues.leanToName, syncValues.isLeftPorch, leftPorchLength, connectRailDataArr, syncValues.legType, syncValues.position, leanToKey, syncValues.isLegTypeChanged, syncValues.legType])

    return (
        <group name='leanto_legs'>
            {syncValues.leanToFrontWallCloseState === 'Close' &&
                <>
                    {CSGFrontBackPillarRailModelArr.frontModelArr.map((item, index_front) =>
                        (leanToKey === 'front' || leanToKey === 'left') ?
                        <mesh name='lean_leg' key={`front-vertical-rail-${index_front}`} geometry={item.geometry} position={[syncValues.length / 2 - (leanToKey === 'left' && 0.05) - ((leanToKey === 'front' || leanToKey === 'back') ? railWidth : 0), 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                        :
                        <mesh name='lean_leg' key={`front-vertical-rail-${index_front}`} geometry={item.geometry} position={[-syncValues.length / 2 + (leanToKey === 'right' && 0.05) + ((leanToKey === 'front' || leanToKey === 'back') ? railWidth : 0), 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    <mesh name='lean_leg_base_rail' geometry={CSGFrontBackBottomRailData.CSGFrontBottomRailModel.geometry} position={[(leanToKey === 'right' || leanToKey === 'back' ? -1 : 1) * (syncValues.length / 2 - ((leanToKey === 'front' || leanToKey === 'back') ? railWidth : 0)), 0, 0]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </>
            }

            {syncValues.leanToBackWallCloseState === 'Close' &&
                <>
                    {CSGFrontBackPillarRailModelArr.backModelArr.map((item, index_back) =>
                     (leanToKey === 'front' || leanToKey === 'left') ?
                        <mesh name='lean_leg' key={`back-vertical-rail-${index_back}`} geometry={item.geometry} position={[-syncValues.length / 2 + (leanToKey === 'left' && 0.05) + ((leanToKey === 'front' || leanToKey === 'back') ? railWidth : 0), 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                        :
                        <mesh name='lean_leg' key={`back-vertical-rail-${index_back}`} geometry={item.geometry} position={[syncValues.length / 2 - (leanToKey === 'right' && 0.05) - ((leanToKey === 'front' || leanToKey === 'back') ? railWidth : 0), 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    <mesh name='lean_leg_base_rail' geometry={CSGFrontBackBottomRailData.CSGBackBottomRailModel.geometry} position={[(leanToKey === 'right' || leanToKey === 'back' ? -1 : 1) * (-syncValues.length / 2 + ((leanToKey === 'front' || leanToKey === 'back') ? railWidth : 0)), 0, 0]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </>

            }
            
            {(leanToKey === 'front' || leanToKey === 'back') && (
                <>
                    {CSGPillarRailModelArr.innerModelArr.map((item, index) => 
                        ((leanToKey === 'front') ? (params.p_f_w !== 'Close') : (params.p_b_w !== "Close")) && (
                            <mesh key={`inner-${index}`} name='front-inner-pillar-model' geometry={item.geometry}>
                                <MaterialTruss normalMap={normalMap} envMap={envMap} />
                            </mesh>
                        )
                    )}
                    {CSGBottomRailModelArr.modelArr.map((item, index) => (
                        <mesh key={`back-${index}`} name='front-inner-pillar-model' geometry={item.back.geometry}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    ))}
                </>
            )}
            {CSGPillarRailModelArr.outerModelArr.map((item, index) => csgLegIdArr.includes(index) &&
                <mesh name='outer-pillar-model' geometry={item.geometry}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}

            {/* --- outer pillar model --- */}
            {outerPillar.array.length > 0 && [1].map((item) => <instancedMesh key={outerPillar.array.length} instanceMatrix-needsUpdate={true} instanceMatrix={outerPillar} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(outerRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }

            {(syncValues.isLegTypeChanged == true && (syncValues.legType =="double" || syncValues.legType == "ladder" || syncValues.legType == "zigzag")) ?
                CSGPillarRailModelArr.outerInModelArr.map((item, index) => csgLegIdArr.includes(index) &&
                    <mesh name='outer-in-pillar-model' geometry={item.geometry}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>)
                :
                null
            }
            {CSGBottomRailModelArr.modelArr.map((item) =>
                <mesh name='outer-pillar-model' geometry={item.outer.geometry}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}
            {(syncValues.isLegTypeChanged == true && (syncValues.legType =="double" || syncValues.legType == "ladder" || syncValues.legType == "zigzag")) ? CSGBottomRailModelArr.modelArr.map((item) =>
                <mesh name='inner-pillar-model' geometry={item.inner.geometry}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            ) : null}
            {/* {(syncValues.isLegTypeChanged == true && (syncValues.legType == "ladder" || syncValues.legType == "zigzag")) && CSGPillarRailModelArr.connectModelArr.map((item, index) =>
                    <mesh key={`connect-rail-${index}`} geometry={item.geometry} >
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
            )} */}

            {
                syncValues.isLegTypeChanged == true && (syncValues.legType == "ladder" || syncValues.legType == "zigzag") && connectBottomRail.array.length > 0 && [1].map((item) => <instancedMesh key={connectBottomRail.array.length} instanceMatrix-needsUpdate={true} instanceMatrix={connectBottomRail} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(outInDistance)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }
            {
                syncValues.isLegTypeChanged == true && (syncValues.legType == "ladder" || syncValues.legType == "zigzag") && connectRail.array.length > 0 && [1].map((item) => <instancedMesh key={connectRail.array.length} instanceMatrix-needsUpdate={true} instanceMatrix={connectRail} args={[null, null, pillarRailDataArr.length * (connectRailDataArr.dataInfoArray.length - 1)]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(railHeight, railWidth), syncValues.legType === 'ladder' ? extrudeSettings(connectRailDataArr.lengthLadder) : syncValues.legType === 'zigzag' ? extrudeSettings(connectRailDataArr.lengthZigzag) : 0]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }

            {/* --- inner pillar model --- */}
            {
                (syncValues.isLegTypeChanged == true && (syncValues.legType =="double" || syncValues.legType == "ladder" || syncValues.legType == "zigzag")) && innerPillar.array.length > 0 && [1].map((item) => <instancedMesh key={innerPillar.array.length} name='leanto-leg' instanceMatrix-needsUpdate={true} instanceMatrix={innerPillar} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(innerRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }
            {/* ------------------------- */}

            <>
                {/* --- upper truss model --- */}
                {upperTrussNormal.array.length > 0 && [1].map((item) =>
                    <instancedMesh key={upperTrussNormal.array.length} instanceMatrix={upperTrussNormal} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(verticalRailLength - extraLength)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>
                )}
                {/* ------------------------- */}

                {/* --- slope rail model --- */}
                {
                    sideSlopeRail.array.length > 0 && [1].map((item) => <instancedMesh key={sideSlopeRail.array.length} instanceMatrix={sideSlopeRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[railModel(railHeight, railWidth), extrudeSettings(edgeSlopeRailLength - cbFrontBackWallOffset)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {/* ------------------------- */}

                {/* --- loft piece rail model --- */}
                {
                    loftPieceRail.array.length > 0 && [1].map((item) => <instancedMesh key={loftPieceRail.array.length} instanceMatrix={loftPieceRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                            <extrudeGeometry args={[railLoftModel(railWidth, syncValues.pitch), extrudeSettings(railHeight)]} />
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </instancedMesh>
                    )
                }
                {/* ------------------------- */}

                {/* --- roof base rail model --- */}
                {
                    baseRail.array.length > 0 && [1].map((item) =>  <instancedMesh key={baseRail.array.length} instanceMatrix={baseRail} instanceMatrix-needsUpdate={true} args={[null, null, roofPatternRailDataArr.length]} frustumCulled={false}>
                        <extrudeGeometry args={[roofBaseRailModel(), extrudeSettings(syncValues.length)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </instancedMesh>)
                }
                {/* ------------------------- */}
            </>
        </group>
    )
}

export default PillarLegs